export default [
  {
    name: "organisationName",
    title: 'Organisation Name',
    width: "60%",
    sortField: "organisationName",
    formatter(value) {
      if (value) {
        return value;
      }else{
        return '--';
      }
    }
  },
  {
    name: "email",
    title: 'Email',
    width: "10%",
    sortField: "email",
    formatter(value) {
      if (value) {
        return value;
      }else{
        return '--';
      }
    }
  },
  {
    name: "Phone",
    title: 'Phone Number',
    width: "10%",
    sortField: "Phone",
    formatter(value) {
      if (value) {
        return value;
      }else{
        return '--';
      }
    }
  }
]